import css from 'styled-jsx/css';

const styles = css.global`#boleto-mudanca-razao-social {
    background: #F5F9FB;
    padding: 40px 0;
}

#boleto-mudanca-razao-social .ctn-home-24 {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 24px;
}

#boleto-mudanca-razao-social .boleto-mudanca-razao-social-textos {
    display: flex;
    flex-direction: column;
    gap: 24px;
}

#boleto-mudanca-razao-social .mudanca-razao-social-titulo {
    color: #444;
    font-family: "SantanderText";
    font-size: 30px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%;
    margin: 0;
}

#boleto-mudanca-razao-social .mudanca-razao-social-texto {
    color: #444;
    font-family: "SantanderText";
    font-size: 17px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
}

#boleto-mudanca-razao-social .mudanca-razao-social-texto b {
    font-weight: 600;
}

@media (min-width: 992px) {
    #boleto-mudanca-razao-social {
        padding: 48px 0;
    }
    #boleto-mudanca-razao-social .ctn-home-24 {
        flex-direction: row-reverse;
        gap: 72px;
    }
}`;

export default styles;